<template>
  <v-row>
    <v-dialog v-model="dialog" persistent width="600px" scrollable>
      <v-card v-if="dialog">
        <v-card-title
          class="text-h6 text-uppercase black--text font-weight-bold"
        >
          <v-spacer></v-spacer>
          <div>Nego Harga</div>
          <v-spacer></v-spacer>
          <v-btn text small color="pink" @click="hideDialog" class="mr-n3">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12">
              <!-- <v-data-table
                :headers="headers"
                :hide-default-header="true"
                :hide-default-footer="true"
                :items="data"
                :items-per-page="5"
                class="elevation-1"
              >
                <template v-slot:item.product_name="{ item }">
                  <v-row>
                    <v-col cols="12">
                      <div class="text-h6 font-weight-bold">
                        {{ item.product_name }}
                      </div>
                      <div class="text-body-2">
                        Harga : {{ item.cart_detail_price | toNumber }}
                      </div>
                    </v-col>
                    <v-col>
                      Harga Nego : {{ item.cart_detail_price_nego }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn>Setujui</v-btn>
                      <v-btn>Tolak</v-btn>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table> -->

              <!-- // {
              // "trx_detail_id": "49",
              // "trx_detail_product_id": "2",
              // "trx_detail_product_name": "AMOX-AB - Amoxsan 500 Mg Kapsul",
              // // "trx_detail_price": 16850,
              // // "trx_detail_price_nego": "15000",
              // // "trx_detail_status_nego": "submitted",
              // // "trx_detail_nego_is_member": "1",
              // // "trx_detail_nego_is_seller": "0"
              // // } -->
              <!-- <v-card elevation="0" class="rounded-lg"> -->
              <template v-if="data.length > 0">
                <v-row v-for="(form, i) in data" :key="i" class="px-3">
                  <!-- <pre>{{ form }}</pre> -->
                  <v-col cols="12">
                    <div class="text-h6 font-weight-bold">
                      {{ form.trx_detail_product_name }}
                    </div>
                    <div class=" ">
                      Harga Asli: {{ form.trx_detail_product_price | toNumber }}
                    </div>
                    <div v-if="form.trx_detail_status_nego !== 'submitted'" style="font-weight:bold" class="  ">
                      Harga Nego {{  form.trx_detail_nego_is_seller == '1' ? 'Ditawarkan' : 'Diajukan' }}: {{ form.trx_detail_price_nego | toNumber }}
                    </div>
                  </v-col>
                  <v-col  v-if="form.trx_detail_status_nego == 'submitted'" cols="12">
                    <v-form v-model="valid" ref="formNego" role="form">
                      <label class="text-body-2 font-weight-bold"
                        >Harga Nego Ditawarkan</label
                      >
                      <div class="d-flex">
                        <v-currency-field
                          v-model="form.trx_detail_price_nego_seller"
                          outlined
                          dense
                          validate-on-blur
                          :disabled=" 
                            form.trx_detail_nego_is_seller == '1'
                          "
                          hide-details
                          :max="form.trx_detail_price"
                          placeholder="Masukkan Harga Yang Diinginkan"
                          class="rounded-lg text-body-2"
                        ></v-currency-field>
                        <!-- <v-btn
                          v-if="form.trx_detail_nego_is_member == '1'"
                          text
                          color="warning"
                          :disabled="form.trx_detail_status_nego == ''"
                          class="text-capitalize mr-2"
                          @click="form.trx_detail_status_nego = ''"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn> -->
                      </div>
                      <template v-if="form.trx_detail_price_nego_seller !== 0">
                        <!-- <small
                          class="text-danger"
                          v-if="form.trx_detail_price_nego_seller < form.min_price_nego"
                          >Harga nego tidak boleh lebih rendah dari harga minimal
                          nego
                        </small> -->
                        <small
                          class="text-danger red--text"
                          v-if="
                            form.trx_detail_price_nego_seller >
                            form.trx_detail_product_price
                          "
                          >Nilai melebihi harga produk</small
                        >
                      </template>
                    </v-form>
                  </v-col>
                  <v-col cols="12">
                    <div class="d-flex justify-end">
                      <!-- <v-btn
                        color="primary" :disabled="form.trx_detail_nego_is_seller == '1'"
                        :outlined="form.trx_detail_status_nego !== 'submitted'"
                        class="text-capitalize mr-2"
                        @click="ajukanNego(i)"
                      >
                        Ajukan
                      </v-btn> -->

                      <v-radio-group
                        :disabled="form.trx_detail_nego_is_seller == '1'"
                        v-model="form.trx_detail_status_nego"
                        row
                      >
                        <v-radio label="Penawaran Harga Lain"  value="submitted"></v-radio>
                        <v-radio label="Setujui" value="approved"></v-radio>
                        <v-radio label="Tolak" value="rejected"></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <v-row>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn
                    :disabled="checkTrxNegoUpdatedSeller"
                    color="primary"
                    @click="saveNego"
                    class="text-capitalize"
                  >
                    Simpan
                  </v-btn>
                </v-col>
              </v-row>
              <!-- </v-card> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      loadingProcess: false,
      rules: [
        (v) =>
          v < this.data.min_price_nego ||
          "Nilai kurang dari harga minimum nego",
        (v) => v > this.data.subtotal || "Nilai melebihi harga produk",
      ],
      headers: [
        {
          text: "Info Pesanan",
          align: "start",
          sortable: false,
          value: "product_name",
        },
        { text: "action", value: "data-table-expand" },
      ],
    };
  },
  props: {
    value: Boolean,
    data: Array,
    trx_id: String,
    varian_selected: Object,
  },

  watch: {
    responseError: {
      handler(val) {
        if (val.cart_detail_price_nego) {
          this.loadingProcess = false;
          this.$store.commit(
            "makeAlert",
            {
              code: "error",
              type: "error",
              message: val.cart_detail_price_nego.message,
              show: true,
            },
            { root: true }
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    checkTrxNegoUpdatedSeller() {
      return this.data.some((i) => i.trx_detail_nego_is_seller == "1");
    },
    ...mapState("cart", ["responseError"]),
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    saveNego() {
      let inputForm = this.data.map((i) => {
        const {
          trx_detail_id,
          trx_detail_product_id,
          trx_detail_product_name,
          trx_detail_product_price,
          trx_detail_price_nego,
          trx_detail_price_nego_seller,
          trx_detail_status_nego,
          trx_detail_nego_is_member,
          trx_detail_nego_is_seller,
        } = i;
        return {
          trx_detail_id,
          trx_detail_product_id,
          trx_detail_product_name,
          trx_detail_product_price,
          trx_detail_status_nego,
          trx_detail_price_nego:
            trx_detail_status_nego == "submitted"
              ? trx_detail_price_nego_seller
              : trx_detail_price_nego,
          trx_detail_nego_is_member:
            trx_detail_status_nego == "submitted" ? "0" : "1",
          trx_detail_nego_is_seller:
            trx_detail_status_nego == "submitted" ? "1" : "0",
        };
      });

      try {
        this.data.forEach((i) => {
          if (i.trx_detail_price_nego_seller > i.trx_detail_product_price) {
            throw new Error(
              `Nilai melebihi harga produk ${i.trx_detail_product_name}`
            );
          }
        });

        this.$store
          .dispatch("transaksiSeller/updatePesananNego", {
            trx_id: this.trx_id,
            trx_nego_items: inputForm,
          })
          .then(() => {
            this.$store.commit(
              "makeAlert",
              {
                code: "success",
                type: "success",
                message: "Berhasil mengubah transaksi nego",
                show: true,
              },
              { root: true }
            );
            this.$emit('updateData',{item:{trx_id:this.trx_id}})
            this.hideDialog();
          });
      } catch (error) {
        this.$store.commit(
          "makeAlert",
          {
            code: "error",
            type: "error",
            message: error,
            show: true,
          },
          { root: true }
        );
      }
    },
    hideDialog() {
      this.dialog = false;
      this.loadingProcess = false; 
    },
    ajukanNego(i) {
      this.data[i].trx_detail_status_nego = "submitted";
      // this.data[i].trx_detail_nego_is_member = "0";
      // this.data[i].trx_detail_nego_is_seller = "1";
    },
    batalkanNego(i) {
      this.loadingProcess = true;
      let {
        cart_detail_id,
        cart_detail_product_id,
        cart_detail_price: subtotal,
      } = this.data[i];
      this.$store
        .dispatch("cart/updateItemCartNego", {
          cart_detail_id,
          cart_detail_product_id,
          cart_detail_price: subtotal,
          cart_detail_price_nego: 0,
        })
        .then(() => {
          this.hideDialog();
          this.$emit("updateCart");
          this.$store.commit(
            "makeAlert",
            {
              code: "success",
              type: "success",
              message: "Berhasil merubah harga nego",
              show: true,
            },
            { root: true }
          );
        });
    },
  },
};
</script>
